// Where, which way and when a photo was taken — the one difference between a
// photo just taken and one chosen from the library (issue #436). Both are
// then saved by addPhoto the same way.
import { bearingForPhoto } from './compass';
import type { PhotoPlace } from './condition-records';
import { positionNow } from './location';
import { EXIF_HEAD_BYTES, readPhotoExif } from './photo-exif';

/** The photo's own EXIF, from the head of the file. */
const exifOf = async (file: File) => readPhotoExif(await file.slice(0, EXIF_HEAD_BYTES).arrayBuffer());

/** A photo just back from the camera: the device's position and compass now; the camera's name from the file. */
export async function cameraPlace(file: File): Promise<PhotoPlace> {
  // Read as the camera hands back: the way the device faces now is the way it faced for the shot.
  const bearing = await bearingForPhoto();
  return { takenAt: new Date().toISOString(), bearing, position: positionNow(), method: 'Camera', camera: (await exifOf(file)).camera };
}

/**
 * A photo chosen from the library: only what its EXIF says, never the
 * device's reading now. No position or direction there = none recorded (set
 * the direction by hand); no time = the time it was added.
 */
export async function uploadPlace(file: File): Promise<PhotoPlace> {
  const exif = await exifOf(file);
  return { takenAt: exif.takenAt ?? new Date().toISOString(), bearing: exif.bearing, position: exif.position, method: 'Library', camera: exif.camera };
}
